// Search fields are not always strings: numeroFianza, numeroContrato and
// telefonoContacto arrive as numbers from some XMLs and manual captures.
// Lowercasing a number throws inside render and takes the whole app down,
// so every search filter coerces through here first.
export const texto = (v) => (v === null || v === undefined ? '' : String(v)).toLowerCase();
